import { createFileRoute } from "@tanstack/react-router"

import WorkInProgressAlert from "@/components/common/Alerts/WorkInProgressAlert"

export const Route = createFileRoute("/app/orders/$companyId/$shipToLocationId/_layout/closed-sales-orders")({
  component: WorkInProgressAlert,
})
